export const DEV_STATUS = {
  EM_DESENVOLVIMENTO: "Em desenvolvimento",
  EM_TESTES: "Em testes",
  AJUSTES: "Ajustes necessários",
  APROVADO: "Aprovado",
  TRANSFORMADO: "Transformado em produto",
  DESATIVADO: "Desativado",
  RESULTS: {
    FALHOU: "Falhou",
    AJUSTES: "Precisa de ajustes",
    APROVADO: "Aprovado",
  },
};

export const devStatusCls = (status) =>
  ({
    EM_DESENVOLVIMENTO: "border-sky-500/40 bg-sky-500/15 text-sky-300",
    EM_TESTES: "border-brand/40 bg-brand/15 text-brand",
    AJUSTES: "border-amber-500/40 bg-amber-500/15 text-amber-300",
    APROVADO: "border-emerald-500/40 bg-emerald-500/15 text-emerald-300",
    TRANSFORMADO: "border-violet-500/40 bg-violet-500/15 text-violet-300",
    DESATIVADO: "border-white/15 bg-secondary/60 text-muted-foreground",
  }[status] || "border-white/15 bg-secondary/60 text-muted-foreground");

export const resultCls = (result) =>
  ({
    FALHOU: "border-destructive/40 bg-destructive/15 text-red-300",
    AJUSTES: "border-amber-500/40 bg-amber-500/15 text-amber-300",
    APROVADO: "border-emerald-500/40 bg-emerald-500/15 text-emerald-300",
  }[result] || "border-white/15 bg-secondary/60 text-muted-foreground");
